<mat-sidenav-container autosize>
  <mat-sidenav #sidenav mode="side" [opened]="openedByDefault">
    <ng-content select="[sidenav]"></ng-content>
  </mat-sidenav>

  <ng-content></ng-content>

</mat-sidenav-container>